import api from '@/api.js';
const state = {
    groups: [],
    faces: [],
    selectedGroup: null,
    unknownGroupId: null,
    spareGroupId: null
};
const mutations = {
    setGroups(state, groups) {
        state.groups = groups;
    },
    setFaces(state, faces) {
        state.faces = faces;
    },
    setSelectedGroup(state, groupId) {
        state.selectedGroup = groupId;
    },
    setSpecialGroups(state, { unknown, spare }) {
        state.unknownGroupId = unknown;
        state.spareGroupId = spare;
    }
};
const getters = {
    groups: (state) => state.groups,
    faces: (state) => state.faces,
    selectedGroup: (state) => state.selectedGroup
};
const actions = {
    async loadGroups({ commit }) {
        const res = await api.faceGroups.list();
        commit('setGroups', res.data);
    },
    async loadFacesForGroup({ commit }, groupId) {
        const res = await api.faceGroups.faces(groupId);
        commit('setFaces', res.data);
        commit('setSelectedGroup', groupId);
    },
    async renameGroup(_, { id, name }) {
        await api.faceGroups.rename(id, name);
    },
    async moveFacesToGroup({ dispatch, state }, { faceIds, targetGroupId }) {
        await api.faceGroups.moveFaces(faceIds, targetGroupId);
        if (state.selectedGroup) {
            dispatch('loadFacesForGroup', state.selectedGroup);
        }
    },
    async deleteFace({ dispatch, state }, faceId) {
        await api.faceGroups.deleteFace(faceId);
        if (state.selectedGroup) {
            dispatch('loadFacesForGroup', state.selectedGroup);
        }
    },
    async addManualFace(_, faceData) {
        await api.faceGroups.addFace(faceData);
    },
    async mergeGroups({ dispatch }, { sourceGroupId, targetGroupId }) {
        await api.faceGroups.mergeGroups(sourceGroupId, targetGroupId);
        dispatch('loadGroups');
    },
    async loadSpecialGroups({ commit }) {
        const res = await api.faceGroups.special();
        commit('setSpecialGroups', res.data);
    },
    async markAsUnknown({ dispatch, state }, faceIds) {
        if (state.unknownGroupId)
            dispatch('moveFacesToGroup', { faceIds, targetGroupId: state.unknownGroupId });
    },
    async markAsUninteressant({ dispatch, state }, faceIds) {
        if (state.spareGroupId)
            dispatch('moveFacesToGroup', { faceIds, targetGroupId: state.spareGroupId });
    },
    async assignToGroupByName({ dispatch, rootState }, { mediaId, faceIndex, groupName }) {
        console.log('assign to group', mediaId, faceIndex, groupName);
        try {
            await api.faceGroups.assignToGroup(mediaId, faceIndex, groupName);
            await dispatch("media/item", mediaId, { root: true });
        }
        catch (error) {
            console.error("Fehler beim Zuweisen zur Gruppe:", error);
        }
    },
};
export const FaceGroups = {
    namespaced: true,
    state,
    mutations,
    getters,
    actions
};
